/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div>
    <absolute-loader :showLoader="loading"></absolute-loader>
    <template v-if="products">
      <div class="wrapp-title">
        <h1 v-t="'checkout.resume'"/>
      </div>
      <!-- product section -->
      <div class="products">
        <div class="products-table bcm-scrollbar">
          <resume-product
          v-for="prod in products"
          :key="prod.item_id"
          :product="prod"/>
        </div>
        <!-- coupon -->
        <summary-price class="info-payments"/>
        <price-manager-button />
        <coupons-manager-button />
      </div>
    </template>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import ResumeProduct from './ResumeProduct'
import SummaryPrice from 'theme/components/Checkout/Cart/SummaryPrice'
import ResumeInfo from 'theme/components/Checkout/OnePage/ResumeInfo'
import CouponsManagerButton from 'theme/components/Checkout/Cart/Coupons/CouponsManagerButton'
import PriceManagerButton from 'theme/components/Checkout/PriceAdjustements/PriceManagerButton'

export default {
  name: 'ResumeSection',
  data: () => ({
    loading: false
  }),
  computed: {
    products () {
      return this.$store.state.cart.items
    }
  },
  methods: {
    async reload () {
      this.loading = true
      await this.$store.dispatch('cart/totals')
      this.loading = false
    }
  },
  mounted () {
    if (process.client) {
      EventBus.$on('checkout:updResume', this.reload)
    }
  },
  destroyed () {
    EventBus.$off('checkout:updResume', this.reload)
  },
  components: {
    AbsoluteLoader,
    ResumeProduct,
    SummaryPrice,
    ResumeInfo,
    CouponsManagerButton,
    PriceManagerButton
  }
}
</script>
